import React, { useState, useEffect, useContext, useMemo } from "react";
import "./team.scss";
import axios from "axios";
import { useParams } from "react-router";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";

function BranchManager() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  const { slug: rawSlug } = useParams();
  const [content, setContent] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // Resolve slug and title once on mount or when rawSlug/nep changes
  const slug = useMemo(() => {
    if (rawSlug === "branch-managers") {
      setPageTitle(nep ? " शाखा प्रबन्धकहरू" : "Branch Managers");
      return "branch-manager";
    } else if (rawSlug === "extension-incharge") {
      setPageTitle(
        nep ? "विस्तारित काउन्टर इन्चार्ज" : "Extension Counter Incharge",
      );
      return "extension-incharge";
    } else {
      setPageTitle(nep ? "अपाङ्गमैत्री शाखा" : "Differently Abled Friendly Branch");
      return "disabled-friendly-branch";
    }
    // Default case

    setPageTitle("Branch Manager");
    return rawSlug;
  }, [rawSlug, nep]);

  const APIURL = `${process.env.REACT_APP_URL}team/all/${slug}`;
  // console.log("UR", APIURL);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setContent(response.data.items);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [APIURL]);

  const MainData = useMemo(() => {
    if (!content) return [];
    return nep ? content.np : content.en;
  }, [content, nep]);

  if (loading) return <Loading />;
  if (error) return <Errors />;
  // console.log(MainData);
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InsidePageContainer">
        <div className="wrapper">
          {rawSlug === "disabled-friendly-branch" ? (
            <div className="BranchManagerContainer">
              <div className="BranchManager">
                <h2>Binita Shrestha</h2>
                <p>Head Office</p>
                <p>Hariharbhawan, Pulchowk</p>
                <p>01-5450406, 01-5437407</p>
                <p>9841054600</p>
                <p>binita.shrestha@gmbf.com.np</p>
              </div>
              <div className="BranchManager">
                <h2>Raj Kumar Mahato Tharu</h2>
                <p>Birgunj Branch</p>
                <p>Aadarsh Nagar, Birgunj</p>
                <p>051-526901,051-526902</p>
                <p>9854038760</p>
                <p>rajkumar.mahato@gmbf.com.np</p>
              </div>
              <div className="BranchManager">
                <h2>Bishal Sapkota </h2>
                <p>Birtamod Branch</p>
                <p>Sanischare Road, Jhapa</p>
                <p>023-590529/023-590532</p>
                <p>9841248803</p>
                <p>bishal.sapkota@gmbf.com.np</p>
              </div>
              <div className="BranchManager">
                <h2>Barun Paudel</h2>
                <p>Butwal Branch</p>
                <p>Amarpath, Butwal</p>
                <p>071-530136/071-530137</p>
                <p>9857064168</p>
                <p>barun.paudel@gmbf.com.np</p>
              </div>
            </div>
          ) : (
            <div className="BranchManagerContainer">
              {MainData.length === 0
                ? "No Team Found."
                : MainData.map((team) => (
                    <div key={team.id} className="BranchManager">
                      <h2>{team?.name}</h2>
                      <p>
                        {/* <b>{nep ? "शाखा" : "Branch"} : </b> */}
                        {team?.branch}
                      </p>
                      <p>{team?.address}</p>
                      <p>{team?.contact}</p>
                      <p>{team?.email}</p>
                    </div>
                  ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default BranchManager;
